import * as documentAccess from './document-access';
import * as windowAccess from './window-access';

function getDateInDays(numDays) {
  const expirationDate = new Date();
  expirationDate.setDate(expirationDate.getDate() + numDays);
  return expirationDate.toUTCString();
}

export function setCookie({ name, expirationDays, multiDomain }) {
  const cookieDirectives = [
    `${name}=1`,
    'Path=/',
    `Expires=${getDateInDays(expirationDays)}`,
  ];

  if (multiDomain) {
    const [hostname] = windowAccess.getLocation().host.split(':');
    const domain = hostname.split('.').slice(-2).join('.');
    cookieDirectives.push(`Domain=${domain}`);
  }

  documentAccess.setCookie(cookieDirectives.join('; '));
}

export function hasCookie({ name }, cookieSource) {
  return (typeof cookieSource === 'string'
    ? cookieSource
    : documentAccess.getCookies()
  )
    .split('; ')
    .some(cookieInJar => cookieInJar === `${name}=1`);
}
